import React, { useEffect, useState } from 'react'
import Layout from '../Layout/Layout'
import { Link, NavLink, useLocation, useNavigate } from 'react-router-dom'
import axios from 'axios';
import { useAuth } from '../../context/auth';
import {Form} from 'react-bootstrap';
import { addCartDataAfterLogin } from '../../Helper';
function LoginWithEmail() {
    const [email, setEmail] = useState("");
    const [password, setPassword]=useState("");
    const [lauth, setLauth] = useAuth();
    const navigate  = useNavigate();
    const [validated, setValidated] = useState(false);
    const [errMsg, setErrMsg] = useState({});
    const [loading, setLoading] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const location = useLocation();
    useEffect(() => {
        let isAuth = JSON.parse(localStorage.getItem('auth'));
        console.log(isAuth)
        if(isAuth && isAuth !== null) {
            navigate("/");
        }
        //eslint-disable-next-line
    }, []);

    const handleSubmit = async (event)=>{
        setErrMsg({});
        setLoading(true)
        setSubmitting(true)
        const form = event.currentTarget;
        event.preventDefault();
        //console.log(form)
        if (form.checkValidity() === false) {
            event.stopPropagation();
            setLoading(false)
            setSubmitting(false)
        }
        setValidated(true);
        if(form.checkValidity()===true) {
            try {
                let {data} = await axios.post(`${process.env.REACT_APP_API_URL}/auth/login_email`,{email,password});
                if(data?.status){
                    setLauth({
                        ...lauth,
                        user:data.results,
                        token:data.token
                    })
                    
                    localStorage.setItem('auth',JSON.stringify({
                                                                ...lauth,
                                                                user:data.results,
                                                                token:data.token
                                                            }))
                 
                    addCartDataAfterLogin();                    
                    navigate(location.state || "/");
                    setLoading(false)
                    setSubmitting(false)
                }else if(!data?.status){
                    setLoading(false)
                    setSubmitting(false)
                    setErrMsg({cls:'alert alert-danger text-center', msg:data?.message});
                }
            } catch (error) {
                setLoading(false)
                setSubmitting(false)
                setErrMsg({cls:'alert alert-danger text-center', msg:'Please check email and password!'});
                console.log(error)
            }
        }

    }

    const [passShow, setPassShow] = useState(false);
    const passtoggle=()=>{
        setPassShow(!passShow)        
    }



  return (
    <Layout title="Log in | Chaashni Couture" >
        <div className="site-content-wrap login">
            <div className={`loginbox ${loading?'loading-old':''}`}>
                <h2>LOGIN / SIGN UP</h2>
                <div className='login-inner'>
                    <div className='login-tab'>
                        <ul>                            
                            <li><NavLink className="active nav-link" to="/login">LOGIN</NavLink></li>
                            <li><NavLink className="nav-link" to="/register">CREATE A NEW ACCOUNT</NavLink></li>
                        </ul>
                    </div>
                    <div className='login-content'>
                    <Form noValidate validated={validated} onSubmit={handleSubmit} className='form-section'>                      
                        {errMsg.cls? <div className={errMsg.cls}>{errMsg.msg}</div>:'' }
                        <div className='login-data'>
                            <input type="email" placeholder="Enter Email" className='form-control input-text' value={email} onChange={(e)=>setEmail(e.target.value)} required />
                        </div>
                        <div className='login-data showhide-password'>
                            <input type={passShow ? "text" : "password"} placeholder="Password" className='form-control input-text' value={password} onChange={(e)=>setPassword(e.target.value)} required/>
                            <span className='showhide-btn' onClick={passtoggle}><i className={`fa-solid ${passShow ? "fa-eye-slash" : "fa-eye"} `}></i></span>
                        </div>
                        <div className='login-data'><button type="submit" className="btn login-with-email" style={{width:"215px"}} disabled={submitting?true:false}>{submitting?'Loading...':'Login with Email'}</button></div>
                        <div className='login-data'><Link to="/recoverpassword" style={{color:'#e61c44'}}>Lost your password?</Link></div>
                        <div className='login-data'><label><input className="" name="rememberme" type="checkbox" value="forever" /> <span>Remember me</span></label></div>
                        <div className='login-data'><Link to="/login">Login with OTP instead</Link></div>
                        <div className='login-data'>Not a Member Yet? Click Here to <Link to="/register" style={{fontWeight:"bold", color:"#000", textDecoration:"none"}}>CREATE A NEW ACCOUNT</Link></div>
                    </Form>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
  )
}

export default LoginWithEmail
